import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';
import { FranchiseFeatureType } from '../franchises/type';

const PronoAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.owner,
  // Prono is always tied to the gift wheel (GAME): having GAME = having Prono.
  featureRestriction: FranchiseFeatureType.GAME,
  routes: [
    {
      path: routesUrl.pronoHistory,
      component: React.lazy(() => import('./pages/PronoHistoryPage')),
    },
    {
      path: routesUrl.pronoCreation,
      component: React.lazy(() => import('./pages/PronoCreationPage')),
    },
    {
      path: routesUrl.pronoDetail,
      component: React.lazy(() => import('./pages/PronoDetailPage')),
    },
  ],
};

export default PronoAppConfig;
